import { getRentalPortalListingPerformance } from '../../../../../../../api'
import { useAsyncEntity } from '../../../../../../Entity'
import { getListingPerformanceEntityId } from '../../RentalPortalListingProfileWidgetPerformance.utils'

export function useListingProfilePerformance(listingData) {
  const entityId = getListingPerformanceEntityId(listingData)

  async function getProfileData() {
    return entityId
      ? getRentalPortalListingPerformance(entityId)
      : Promise.resolve({ data: null })
  }

  const { entityData, isInitiated, isLoading } = useAsyncEntity({
    entityId,
    getProfileData,
  })

  return {
    isPerformanceLoading: isLoading || !isInitiated,
    performance: entityData || null,
  }
}
